import Ad from "@components/Advertisement/Ad";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import { GADataProps } from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import { useInjectClientData } from "@hooks/useInjectClientData";
import LayoutFactory from "@routes/Content/layout/LayoutFactory";
import { ContentPageData } from "@routes/Content/utils/types";

const ContentPagesContent = ({
  urlPath,
  seoFooterData,
  gaProps,
}: ContentPageData & { gaProps: GADataProps }): React.ReactElement => {
  useInjectClientData({ gaProps });

  return (
    <div data-testid="content-pages-content-component" className="w-full">
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <LayoutFactory urlPath={urlPath} />

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default ContentPagesContent;
